<div
  class="images-wrapper"
  [style.height.px]="imgHeight"
  [style.transform]="containerTransform"
  [style.transition-duration]="transitionDuration"
>
  <div *ngFor="let imgUrl of imgUrls" class="image" [style.width.px]="imgWidth">
    <img [src]="imgUrl" class="with-backup" />
  </div>
</div>

<div *ngIf="imgUrls.length > 1">
  <i class="fas fa-angle-right" tabindex="0" (click)="onNextClick()" (keydown)="onNextClick($event)"></i>
  <i class="fas fa-angle-left" tabindex="0" (click)="onBackClick()" (keydown)="onBackClick($event)"></i>
</div>
